﻿import React, { useContext, useEffect, useState } from "react";

import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { facility } from "../Endpoints";
import { Heading } from "../partials/Heading";
import { HtmlOutput } from "../../../../../Resources/Scripts/_Shared/elements/HtmlOutput";
import Instructions from "../partials/Instructions";
import { minuteToDays } from "../util";

const OrderConfirmation = () => {
    const { waitingListFlowContext } = useContext(WaitingListFlowContext);
    const typeformId = "01HV4161P35AKJXR3CK4FE76AB";
    const currentCountry = document
        .querySelector("html")
        .getAttribute("country");

    useEffect(() => {
        setTimeout(() => {
            var n = sessionStorage.length;
            while (n--) {
                var key = sessionStorage.key(n);
                if (/__aimo-waitinglist-flow__/.test(key)) {
                    sessionStorage.removeItem(key);
                }
            }
        }, 1000);
    }, []);

    const instructions = [
        waitingListFlowContext.localization.orderConfirmation?.instructions?.step1.replace(
            "[EMAIL]",
            waitingListFlowContext.user.email
        ),
        waitingListFlowContext.localization.orderConfirmation?.instructions?.step2.replace(
            "[X]",
            minuteToDays(
                waitingListFlowContext?.product?.ExpirationLimits
                    ?.WaitingListActivationPermitLock || 0
            )
        ),
        waitingListFlowContext.localization.orderConfirmation?.instructions
            ?.step3,
    ];

    return (
        <div className="waitingListFlowPage__app waitingListFlowPage__app--confirmation">
            <div className="single-step single-step--confirmation">
                <Heading
                    text={
                        waitingListFlowContext.localization.orderConfirmation
                            .heading
                    }
                />
                <p>
                    <HtmlOutput
                        html={waitingListFlowContext.localization.orderConfirmation.text
                            .replace(
                                "[PMC]",
                                `<strong>${
                                    waitingListFlowContext.product
                                        ?.OverviewText || ""
                                }</strong>`
                            )
                            .replace(
                                "[Facility]",
                                `<strong>${waitingListFlowContext.facility.name}</strong>`
                            )}
                    />
                </p>
                <p>
                    <HtmlOutput
                        html={waitingListFlowContext.localization.orderConfirmation.note.replace(
                            "{{link}}",
                            waitingListFlowContext.localization.language ===
                                "sv"
                                ? '<a href="/mitt-aimo-park/startsida-privat/preliminara-ordrar/?" class="force-link">Preliminära abonemang</a>'
                                : '<a href="/en/my-aimo-park/startpage-private/preliminary-orders/?" class="force-link">Preliminary subscriptions</a>'
                        )}
                    />
                </p>

                {waitingListFlowContext.product
                    ?.EnableWaitingListCsrApprovalRequired ? (
                    <></>
                ) : (
                    <p>
                        <HtmlOutput
                            html={
                                waitingListFlowContext.localization
                                    .orderConfirmation.subtext
                            }
                        />
                        <strong>
                            #{waitingListFlowContext?.confirmation?.position}
                        </strong>
                    </p>
                )}
                <Instructions
                    title={
                        waitingListFlowContext.localization.orderConfirmation
                            ?.instructions?.title
                    }
                    instructions={instructions}
                />

                <a
                    href={
                        waitingListFlowContext.localization.language === "sv"
                            ? "/mitt-aimo-park/startsida-privat/preliminara-ordrar/?"
                            : "/en/my-aimo-park/startpage-private/preliminary-orders/?"
                    }
                >
                    {waitingListFlowContext.localization.orderConfirmation.link}
                </a>
            </div>
            {/*Typeform container*/}
            <div style={{ minHeight: "340px" }} data-tf-live={typeformId}></div>
        </div>
    );
};

export default OrderConfirmation;
